import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@Component({
  selector: 'via-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
  imports: [MatProgressSpinnerModule]
})
export class LoadingIndicatorComponent {
  @ViewChild("container") container: ElementRef;

  @Input() size: 'large' | 'small' = 'small';

  get diameter(): number {
    return this.size === 'large' ? 80 : 44;
  }
}
